import { dayjs, interpolateTemplate } from '@trip-ux/common';
import { DAYJS_DIFF } from '@trip-ux/constants';
import { COVERME_STUDENT_TYPES } from '@trip-ux/redux-store';
import { get, isEmpty, isEqual, map } from 'lodash';

export const getCoverageEndDateFocus = (leaveArriveDate, coverageStartDate, coverageEndDate, dateFormat) => {
  const isLeaveArriveDateValid = dayjs(leaveArriveDate, dateFormat, true).isValid();
  const isCoverageStartValid = dayjs(coverageStartDate, dateFormat, true).isValid();
  const isCoverageEndValid = dayjs(coverageEndDate, dateFormat, true).isValid();

  if (isCoverageEndValid) {
    return dayjs(coverageEndDate, dateFormat).toDate();
  }
  if (isLeaveArriveDateValid && isCoverageStartValid) {
    return dayjs(coverageStartDate, dateFormat).toDate();
  } else {
    return dayjs(leaveArriveDate, dateFormat).toDate();
  }
};

export const getPairStartDateFocus = (startDate, endDate, dateFormat) => {
  const isStartDateValid = dayjs(startDate, dateFormat, true).isValid();
  const isEndDateValid = dayjs(endDate, dateFormat, true).isValid();

  let focusDate = dayjs();
  if (isStartDateValid) {
    if (isEndDateValid) {
      focusDate = dayjs(endDate, dateFormat, true);
    } else {
      focusDate = dayjs(startDate, dateFormat, true);
    }
  }

  return dayjs(focusDate, dateFormat).toDate();
};

export const getValidDate = (date, dateFormat) => {
  return dayjs(date, dateFormat, true).isValid() ? dayjs(date, dateFormat).toDate() : null;
};

export const computeDuration = (date: string, dateFormat: string, duration: number) => {
  return dayjs(date, dateFormat, true).add(duration, DAYJS_DIFF.DAYS);
};

export const evaluateLeaveArriveDate = (studentType, arrivingDate, leavingDate) => {
  return isEqual(studentType, COVERME_STUDENT_TYPES.INTERNATIONAL) ? arrivingDate : leavingDate;
};

export const showLeaveArriveDate = (schoolStartDate, schoolEndDate) =>
  !isEmpty(schoolStartDate) && !isEmpty(schoolEndDate);

export const getAheadDate = date => (dayjs().isBefore(date) ? date : new Date());

export const computeTripDuration = (tripStart, tripEnd, dateFormat) => {
  const startDate = dayjs(tripStart, dateFormat, true);
  const endDate = dayjs(tripEnd, dateFormat, true);
  return endDate.diff(startDate, DAYJS_DIFF.DAYS) + 1;
};

export const setTripDetailsLabels = (tripDetails, province) => {
  return {
    ...tripDetails,
    formLabels: {
      ...tripDetails.formLabels,
      arrivingDate: interpolateTemplate(tripDetails.formLabels.arrivingDate, { province })
    }
  };
};

export const getPairArriveDateFocus = (arrivingDate, coverageStartDate, dateFormat) => {
  const currentDate = dayjs();
  const coverageStartDateFormatted = dayjs(coverageStartDate, dateFormat, true);
  const arrivingDateFormatted = dayjs(arrivingDate, dateFormat, true);
  const isCoverageStartDateValid = coverageStartDateFormatted.isValid();
  const isArrivingDateValid = arrivingDateFormatted.isValid();
  let focusDate;

  if (isCoverageStartDateValid) {
    if (isArrivingDateValid && coverageStartDateFormatted.isBefore(arrivingDateFormatted, DAYJS_DIFF.DAYS)) {
      focusDate = arrivingDateFormatted;
    } else {
      focusDate = coverageStartDateFormatted;
    }
  } else {
    if (currentDate.isAfter(arrivingDateFormatted, DAYJS_DIFF.DAYS)) {
      focusDate = dayjs(currentDate, dateFormat, true);
    } else if (currentDate.isSameOrBefore(arrivingDateFormatted, DAYJS_DIFF.DAYS)) {
      focusDate = arrivingDateFormatted;
    }
  }

  return focusDate.toDate();
};

export const getTripPlanDetailsAnalytics = (values, quoteForm, primaryEmail, dateFormat) => {
  const travellers = get(quoteForm, 'travellers', []);
  const superVisa = get(values, 'superVisa');
  const departureDate = get(values, 'departureDate');
  const returnDate = get(values, 'returnDate');
  return {
    plan: {
      planType: get(quoteForm, 'travellerType'),
      province: get(quoteForm, 'province'),
      familyCoverage: get(quoteForm, 'isFamily'),
      superVisa: superVisa ? superVisa : false,
      travelerCount: get(quoteForm, 'travellerCount'),
      emailAddress: primaryEmail,
      tripDestination: get(values, 'destination', ''),
      tripStart: departureDate,
      tripEnd: returnDate,
      tripDuration: computeTripDuration(departureDate, returnDate, dateFormat),
      travelerAge: map(travellers, traveller => traveller.age)
    }
  };
};

export const getDisabledDay = (condition: boolean, trueDate, falseDate) => (condition ? trueDate : falseDate);

export const countries = [
  { label: 'USA', value: 'USA' },
  { label: 'Canada', value: 'Canada' },
  { label: 'International', value: 'International' }
];
